import React, {useEffect} from 'react'
import apiClient from '../http-common';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { setPlans } from './planSlice';

export const LoadPlans = () => {
  const dispatch = useDispatch();
    const { isLoading: isLoadingProducts, refetch: getProducts } = useQuery(
        "plans",
        async () => {
          return await apiClient.get("/api/investment-plans");
        },
        {
          enabled: true,
          refetchOnMount: 'always',
          refetchOnWindowFocus: false,
          cacheTime: 0,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                dispatch(setPlans(res.data.plans));
                const event = new Event('updatedStorage');
                window.dispatchEvent(event);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

      useEffect(() => {
        getProducts();
      }, []);
 
}

export default LoadPlans
